/*
* Prepare datetime. Return object with values.
* */
export function createZonedDateTime(dateTimeAsString, timeZoneOffset) {
    let dateTimeArr = dateTimeAsString.split('T');
    let date = dateTimeArr[0].split('-');
    let time = dateTimeArr[1].split('Z');
    time = time[0].split(':');

    let dateStructure = {
        year: date[0],
        month: date[1] - 1,
        day: date[2],
        hour: time[0],
        minute: time[1],
        second: time[2],
    };

    let utcDateTime = new Date(Date.UTC(dateStructure.year, dateStructure.month, dateStructure.day, dateStructure.hour, dateStructure.minute, dateStructure.second));

    let zonedDateTime = new Date(utcDateTime.getTime() + (timeZoneOffset * 1000 * 3600));
    return zonedDateTime

}
